import { createFileRoute } from '@tanstack/react-router';
import { Header } from '@/components/Header';
import { RoleEdit } from '@/pages/RoleEdit';

export const Route = createFileRoute(
  '/_authenticated/_admin/admin/manage-roles/$roleId/edit'
)({
  component: RoleEditPage,
});

function RoleEditPage() {
  const { roleId } = Route.useParams();

  return (
    <>
      <Header
        enableBack
        fallbackTo="/admin/manage-roles"
        additionalClasses="bg-slate-700"
      />
      <RoleEdit roleId={roleId} />
    </>
  );
}
